<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('transmission.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <error-msg-component :messages="messages" v-if="error"
                        :error="error"
                        :title="'transmission.error.problemOccurred'"
                        @close="error = $event"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllTransmissionSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5">
            <b-input :placeholder="$t('general.button.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permTransmission.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" v-if="startArrayRendering && mountedLoadingEnd"
                    :columns="columns"
                    :options="options"
                    @loaded="finLoading"
                    @loading="debutLoading"
                    :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="transmissions">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props"
           class="has-text-centered">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row">
        </b-checkbox>
      </div>
      <div slot="code" slot-scope="props">
        <b-field>
          <router-link :to="{ name: 'c.bodac.factures', params: {id: props.row.id}}"
                       v-if="!props.row.interne"
                       class="lien" :class="{'text-access-no-permission':
                     !checkPermissions(permTransmission.lecture)}">
            {{props.row.code}}
          </router-link>
          <router-link :to="{ name: 'c.bodac.factures-venteInterne',
                     params: {id: props.row.id}}"
                       v-else
                       class="lien"
                       :class="{'text-access-no-permission':
                     !checkPermissions(permTransmission.lecture)}">
            {{ props.row.code }}
          </router-link>
          <b-tooltip type="is-primary"
                     position="is-right"
                     :label="$t('listeFactures.interne')">
            <b-icon icon="information"
                    class="mgl-5px"
                    size="is-small"
                    v-if="props.row.interne"
                    type="is-primary">
            </b-icon>
          </b-tooltip>
        </b-field>
      </div>
      <div slot="codeDossier" slot-scope="props">
        {{props.row.codeDossier}}
      </div>
      <div slot="commercialId" slot-scope="props">
        {{props.row.nomCommercial}}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(props.row.etatLibelle) }}
      </div>
      <div slot="sousType" slot-scope="props">
        {{ $t(props.row.sousTypeLibelle) }}
      </div>
      <div slot="payeur" slot-scope="props">
        {{ props.row.payeurLibelle }}
      </div>
      <div slot="domTom" slot-scope="props">
        {{ props.row.domTom ? $t('general.oui') : $t('general.non') }}
      </div>
      <div slot="factor" slot-scope="props" class="is-pulled-right">
        {{props.row.tiersFactorLibelle}}
      </div>
      <div slot="factorDateTransmission" slot-scope="props" class="is-pulled-right">
        {{props.row.factorDateTransmission | formatDate}}
      </div>
      <div slot="datePremierAffichage" slot-scope="props">
        {{props.row.datePremierAffichage | formatDate}}
      </div>
      <div slot="dateDevisCommande" slot-scope="props" v-if="props.row.dateDevisCommande">
        {{props.row.dateDevisCommande | formatDate}}
      </div>
      <div slot="montantHt" slot-scope="props" class="is-pulled-right">
        {{props.row.montantHt | formatDevise}}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
        {{props.row.montantTtc | formatDevise}}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
      <div slot="exporter" slot-scope="props"
           class="has-text-centered">
        <a @click="checkPermissions(permTransmission.editer) ?
          inProgress(): showPopUp()">
          <b-icon
            :key="props.id"
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' : !checkPermissions(permTransmission.editer)}">
          </b-icon>
        </a>
      </div>
      <div slot="modifier" slot-scope="props"
           class="has-text-centered">
        <router-link v-bind:to="{ name: 'm.bodac.factures-edition', params: {id: props.row.id}}"
                     :class="{ 'disabled': props.row.etat !== brouillon }">
          <b-icon
            icon="pencil-box-outline"
            :type="{ 'is-success': props.row.etat === brouillon }"
            :class="{'text-access-no-permission' :
              !checkPermissions(permTransmission.maj) && props.row.etat === brouillon}">
          </b-icon>
        </router-link>
      </div>
      <div slot="archive"
           class="has-text-centered">
        <a @click="checkPermissions(permTransmission.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permTransmission.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="supprimer" slot-scope="props"
           class="has-text-centered">
        <a @click="checkPermissions(permTransmission.supprimer) ?
           inProgress() : showPopUp()">
          <b-icon
            :key="props.id"
            icon="delete-forever"
            :type="{ 'is-danger': props.row.etat === brouillon }"
            :class="{'text-access-no-permission' :
              !checkPermissions(permTransmission.supprimer) && props.row.etat === brouillon}">
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="popUpAffecterFactor" has-modal-card class="modal">
      <pop-up-affecter-factor @affecterFactor="factorAffected"/>
    </b-modal>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-facture ref="filtreListeTransmission"
          @toggleFiltre="setShowFiltre()"
          @recherche="makeRechercheFilter()"
          :disabled-filter-parution="!!$route.params.parutionId"
          :isPageTransmission="true"
          :storeName="'transmission'"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import breadcrumb from '@/components/general/breadcrumb';
import TableItemsInView from '@/components/general/TableItemsInView';
import { TRANSMISSION } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import inProgress from '@/services/general/inProgress';
import messageErreur from '@/services/general/messageErreur';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatDate from '@/services/general/formatIsoDate';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { get as getParution } from '@/api/presse/parution';
import { affecterFactorToFacture } from '@/api/facture/index';
import filtreListeFacture from '@/components/factures/filtreListeFacture';
import selecteurAction from '@/components/general/selecteurAction';
import * as devisConf from '@/configuration/devisConf';
import * as transmissionConf from '@/configuration/bodac/transmissionConf';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import edition from '@/api/factor/index';
import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import validationEditionTransmission from '@/services/transmission/validationTransmission';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import { SET_CRITERE, RESET_CRITERE } from '@/store/modules/facture-mutation-type';
import popUpAffecterFactor from '@/components/transmissions/popUpAffecterFactor';
import messageSuccess from '@/services/general/messageSucces';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_TRANSMISSION } from '@/configuration/general/referenceTableConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import { COMMERCIAL } from '@/configuration/parametrage/secteurConf';

const Transmissions = createNamespacedHelpers('transmission');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      permTransmission: TRANSMISSION,
      unsubscribeValue: null,
      showFiltre: false,
      typeFacture: devisConf.TYPE_FACTURE,
      brouillon: devisConf.ETAT_BROUILLON,
      actions: [
        { action: transmissionConf.ACTION_AFFECTER, translation: 'transmission.actions.affecter' },
        { action: transmissionConf.ACTION_TRANSMETTRE, translation: 'transmission.actions.transmettre' },
      ],
      messages: [],
      error: false,
      popUpAffecterFactor: false,
      routeParution: null,
      referenceTable: REFERENCE_TABLE_LISTE_TRANSMISSION,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      mountedLoadingEnd: false,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    filtreListeFacture,
    selecteurAction,
    errorMsgComponent,
    popUpAffecterFactor,
    tableFooterTotaux,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Transmissions.mapGetters({
      transmissions: 'transmissions',
      totalTransmissions: 'totalTransmissions',
      lastPayload: 'lastPayload',
      critereRechercheStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    critereRecherche: {
      get() {
        return this.critereRechercheStore;
      },
      set(newVal) {
        this.setCritere(newVal);
      },
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('transmission.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    iconSelectTotal() {
      if (this.allTransmissionSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    nombreCritere() {
      const banCritere = ['dates', 'datesPremierAffichage', 'interne', 'factorDateTransmission', 'nonFactorisable', 'SansTiersFactorId',
        'factorTransmis', 'sens', 'factureParEmail', 'nePasRelancer'];
      let nombreCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dates) {
        nombreCritere += this.critereRecherche.dates.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.dates.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.datesPremierAffichage) {
        nombreCritere += this.critereRecherche.datesPremierAffichage.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.datesPremierAffichage.dateFin ? 1 : 0;
      }
      if (this.critereRecherche.factorDateTransmission) {
        nombreCritere += this.critereRecherche.factorDateTransmission.dateDebut ? 1 : 0;
        nombreCritere += this.critereRecherche.factorDateTransmission.dateFin ? 1 : 0;
      }
      nombreCritere += this.critereRecherche.interne !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.sansTiersFactorId !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.nonFactorisable !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.factorTransmis !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.factureParEmail !== null ? 1 : 0;
      nombreCritere += this.critereRecherche.nePasRelancer !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    columns() {
      const columns = ['selected', 'code', 'dateDevisCommande', 'sousType', 'payeur', 'domTom', 'factor', 'factorDateTransmission', 'commercialId', 'etat', 'datePremierAffichage', 'codeDossier', 'montantHt', 'montantTtc', 'exporter', 'modifier', 'archive', 'supprimer'];
      if (this.agencesSelectionnees.length > 1) {
        columns.splice(columns.findIndex((column) => column === 'montantHt'), 0, 'agence');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('transmission.table.code'),
          codeDossier: this.$i18n.t('transmission.table.codeDossier'),
          dateDevisCommande: this.$i18n.t('transmission.table.date'),
          sousType: this.$i18n.t('transmission.table.type'),
          payeur: this.$i18n.t('transmission.table.payeur'),
          domTom: this.$i18n.t('transmission.table.domTom'),
          factor: this.$i18n.t('transmission.table.factor'),
          factorDateTransmission: this.$i18n.t('transmission.table.factorDateTransmission'),
          commercialId: this.$i18n.t('transmission.table.commercial'),
          etat: this.$i18n.t('transmission.table.etat'),
          montantHt: this.$i18n.t('transmission.table.montantHt'),
          montantTtc: this.$i18n.t('transmission.table.montantTtc'),
          agence: this.$i18n.t('transmission.table.agence'),
          datePremierAffichage: this.$i18n.t('transmission.table.datePremierAffichage'),
          modifier: '',
          archive: '',
          supprimer: '',
          exporter: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['dateDevisCommande', 'montantHt', 'montantTtc', 'datePremierAffichage', 'sousType', 'etat', 'code', 'codeDossier', 'payeur', 'commercialId'],
        columnsClasses: {
          archive: 'colonneSelected',
          supprimer: 'colonneSelected',
          modifier: 'colonneSelected',
          exporter: 'colonneSelected',
          selected: 'colonneSelected',
        },
        requestFunction: (async (data) => {
          await this.filtreByRouteParutionId();
          return this.actionLoadTransmissions(data);
        }),
      };
    },
    allTransmissionSelected() {
      return this.getAllTransmissionSelected().length === this.transmissions.length;
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    targetTotal() {
      return ['montantHt', 'montantTtc'];
    },
    exportExcelQuery() {
      return {
        typeDonnee: transmissionConf.EXPORT_EXCEL_TYPE_TRANSMISSION,
        typeExport: '',
        filtres: transform(this.lastPayload),
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Transmissions.mapMutations({
      setCritere: SET_CRITERE,
      resetCritere: RESET_CRITERE,
    }),
    ...Transmissions.mapActions({
      actionLoadTransmissions: 'loadTransmissions',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    goFirstPageAndCheckChangement() {
      if (this.critereRecherche.agencesId.length === 0) return;
      const agencesId = [];
      this.critereRecherche.agencesId.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesId.push(id);
      });
      this.critereRecherche.agencesId = agencesId;
      this.$refs[this.referenceTable].setPage(1);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeTransmission.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.resetCritere();
      this.recherche();
      this.showFiltre = false;
    },
    gestionDataLoadTransmissions(data) {
      data.query.societeId = this.societeActiveId;
      if (data.query.dates) {
        data.query.dates.dateDebut = formatDate(data.query.dates.dateDebut);
        data.query.dates.dateFin = formatDate(data.query.dates.dateFin);
      }
      if (data.query.datesPremierAffichage) {
        data.query.datesPremierAffichage.dateDebut = formatDate(
          data.query.datesPremierAffichage.dateDebut,
        );
        data.query.datesPremierAffichage.dateFin = formatDate(
          data.query.datesPremierAffichage.dateFin,
        );
      }
      if (data.query.factorDateTransmission) {
        data.query.factorDateTransmission.dateDebut = formatDate(
          data.query.factorDateTransmission.dateDebut,
        );
        data.query.factorDateTransmission.dateFin = formatDate(
          data.query.factorDateTransmission.dateFin,
        );
      }
      if (data.query.groupeIds.length > 0) {
        data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
      }
      if (data.query.enseigneIds.length > 0) {
        data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => { return enseigne.id; });
      }
      if (this.critereRecherche.agencesId.length === 0) {
        data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
      }
      if (data.query.clients.length > 0) {
        data.query.tiersId = data.query.clients.map((client) => client.id);
      }
      if (data.query.produitsIds.length > 0) {
        data.query.produitsIds = data.query.produitsIds.map(produit => produit.id);
      }
      if (data.query.commandeIds.length > 0) {
        data.query.commandeIds = data.query.commandeIds.map(el => el.id);
      }
      if (data.query.tiersFactorIds.length > 0) {
        data.query.tiersFactorIds = data.query.tiersFactorIds.map(factor => factor.id);
      }
      if (this.modulePresseActive) {
        if (data.query.parutionsIds.length > 0) {
          data.query.parutionsIds = data.query.parutionsIds.map(el => el.id);
        }
        if (data.query.planMediaIds.length > 0) {
          data.query.planMediaIds = data.query.planMediaIds.map(el => el.id);
        }
        if (data.query.regleFacturationIds.length > 0) {
          data.query.regleFacturationIds = data.query.regleFacturationIds.map(el => el.id);
        }
      }
      delete data.query.clients;
      data.query.etat = tagInputToArray(this.critereRecherche.etat, 'code');
      data.query.categorieVente = tagInputToArray(this.critereRecherche.categorieVente, 'code');
      data.query.sousType = tagInputToArray(this.critereRecherche.type, 'code');
      data.query.type = this.typeFacture;
    },
    async filtreByRouteParutionId() {
      if (this.modulePresseActive && this.$route.params.parutionId) {
        if (!this.routeParution) {
          this.routeParution = (await getParution(this.$route.params.parutionId)).data.result;
        }
        this.critereRecherche.parutionsIds = [this.routeParution];
      }
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    selectAll() {
      const select = !this.allTransmissionSelected;
      this.transmissions.forEach((el) => {
        el.selected = select;
      });
    },
    getAllTransmissionSelected() {
      return this.transmissions.filter((el) => {
        return el.selected;
      });
    },
    handleAction(action) {
      switch (action) {
        case transmissionConf.ACTION_TRANSMETTRE:
          this.editionTransmettreFactor(this.getAllTransmissionSelected());
          break;
        case transmissionConf.ACTION_AFFECTER:
          this.popUpAffecterFactor = true;
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('transmission.error.noActionSelect'));
          break;
      }
    },
    async editionTransmettreFactor(transmissionSelectionnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.error = false;
      try {
        const response = await edition({
          typeDonnee: transmissionConf.EXPORT_FACTOR_TRANSMISSION,
          ids: transmissionSelectionnees.map((transmission => transmission.id)),
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEditionTransmission({ data: response }, this.messages);
          this.error = true;
          return;
        }
        throw e;
      }
    },
    async factorAffected(tiersFactorId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await affecterFactorToFacture({
          tiersFactorId: tiersFactorId,
          factureIds: this.getAllTransmissionSelected().map((t => t.id)),
        });
        messageSuccess(this.$i18n.t('transmission.popUpAffecter.success'));
        this.recherche();
        this.popUpAffecterFactor = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      const secteurIdsCurrentUser = (await getSecteursIdByUser(COMMERCIAL)).map(e => e.id);
      if (secteurIdsCurrentUser.length) this.critereRecherche.secteurIds = secteurIdsCurrentUser;
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPageAndCheckChangement);
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pageGescom.transmission.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
};
</script>

<style>

</style>
